import React from "react";
import { formatMoney } from "../../../../features/utils/formatMoney";
import { getChangeSelectedOfferFareHint } from "../../../../data/flight/order/getRequestedDateChange";

/** Amber notice + CTA when the agent picked a selectedOffer. */
export default function ChangeSelectedOfferHint({ data, onView }) {
  const hint = getChangeSelectedOfferFareHint(data);
  if (!hint || !onView) return null;

  const { oldTotal, offerTotal, difference, byPaxType } = hint;
  const money = (amount) => (amount == null ? "—" : formatMoney(amount) || "—");
  const paxDiff = (Array.isArray(byPaxType) ? byPaxType : [])
    .filter((row) => row?.difference != null)
    .map((row) => `${row.label}: ${money(row.difference)}`)
    .join(" · ");

  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50 px-3 py-3">
      <div className="text-sm font-semibold text-amber-900">
        Agent selected an offer
      </div>
      <p className="mt-1 text-sm text-amber-900/90">
        {difference != null ? (
          <>
            Fare difference on the selected offer is about{" "}
            <span className="font-semibold">{money(difference)}</span>
            {oldTotal != null && offerTotal != null ? (
              <>
                {" "}
                (ticket {money(oldTotal)} → offer {money(offerTotal)}).
              </>
            ) : (
              "."
            )}
            {paxDiff ? (
              <>
                {" "}
                By type: {paxDiff}.
              </>
            ) : null}{" "}
            Use this when you enter the quote — it is a guide, not a final
            quote.
          </>
        ) : (
          <>
            Compare the selected offer with the current ticket before you quote.
            The offer totals may help set the fare difference.
          </>
        )}
      </p>
      <button
        type="button"
        onClick={onView}
        className="mt-2.5 inline-flex h-9 items-center rounded-lg border border-amber-300 bg-white px-3 text-sm font-semibold text-amber-950 hover:bg-amber-100"
      >
        View selected offer
      </button>
    </div>
  );
}
